import RUF from "../../../util/redux";

export function metaSetPreviousState(state, action) {
  return RUF.updateObject(state, {
    meta: RUF.updateObject(state.meta, {
      previousState: action.payload
    })
  });
}
